import React, { createContext, useContext, useMemo } from "react";
import { ShoppingCartClient } from "@/react/Webshop/api/ShoppingCartClient";
const ShoppingCartApiClientContext = createContext(null);
export function ShoppingCartApiClientProvider({ client, children, }) {
    const apiClient = useMemo(() => {
        return client !== null && client !== void 0 ? client : new ShoppingCartClient();
    }, [client]);
    console.log("Type of client", typeof apiClient, apiClient);
    return (React.createElement(ShoppingCartApiClientContext.Provider, { value: apiClient }, children));
}
export function useShoppingCartApiClient() {
    const client = useContext(ShoppingCartApiClientContext);
    if (!client) {
        throw new Error("useShoppingCartApiClient must be used inside ShoppingCartApiClientProvider");
    }
    return client;
}
